package fr.frux.feature.map

import fr.frux.shared.domain.model.Tree

/** Rang (à partir de 0) de l'annonce native dans « Autour de toi » : la quatrième ligne (ADR 0030, #530). */
private const val NEARBY_NATIVE_INDEX = 3

/** Nombre minimal d'arbres pour qu'une annonce soit admise : jamais plus d'une, jamais en fin de liste. */
private const val NEARBY_NATIVE_MIN_TREES = NEARBY_NATIVE_INDEX + 1

/** Ligne de la liste « Autour de toi ». */
internal sealed interface NearbyListItem {
    /** Clé stable pour `LazyColumn` : l'id de l'arbre, ou une clé de texte pour l'annonce. */
    val key: Any

    data class TreeEntry(
        val tree: Tree,
    ) : NearbyListItem {
        override val key: Any get() = tree.id
    }

    data object Ad : NearbyListItem {
        override val key: Any = "native-ad"
    }
}

/** La liste a-t-elle assez d'arbres pour réclamer l'emplacement natif ? */
internal fun nearbyNativeRequested(treeCount: Int): Boolean = treeCount >= NEARBY_NATIVE_MIN_TREES

/**
 * Lignes de la liste : les arbres, plus l'annonce en quatrième position seulement si elle est prête
 * ([adReady]) et que la liste compte au moins quatre arbres. Une annonce absente ne laisse aucun trou.
 */
internal fun nearbyListItems(
    trees: List<Tree>,
    adReady: Boolean,
): List<NearbyListItem> {
    val entries = trees.map(NearbyListItem::TreeEntry)
    if (!adReady || !nearbyNativeRequested(trees.size)) return entries
    return entries.take(NEARBY_NATIVE_INDEX) + NearbyListItem.Ad + entries.drop(NEARBY_NATIVE_INDEX)
}
